import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF8C00', // Customize primary color
    },
    secondary: {
      main: '#00BFFF', // Customize secondary color
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif', // Set global font if needed
  },
});

export default theme;
